const state = {
  viewPending: false,
  pending: [],
  handled: [],
};

const getters = {
  hasUnhandledCalls: (state) => {
    const unhandledCalls = state.pending.filter((x) => {
      for (let i = 0; i < state.handled.length; i += 1) {
        if (x.url.indexOf(state.handled[i]) >= 0) {
          return false;
        }
      }
      return x.handleLoading === undefined || x.handleLoading === true;
    });
    if (unhandledCalls.length > 0) {
      return true;
    }
    return false;
  },
  hasPendingCall: state => handle => state.pending.filter(x => x.url.indexOf(handle) >= 0).length > 0,
};

const mutations = {
  viewPending(state, payload) {
    state.viewPending = payload;
  },
  add(state, payload) {
    state.pending.push(payload);
  },
  remove(state, payload) {
    const found = state.pending.find(x => x.url === payload.url);
    if (found) {
      state.pending.splice(state.pending.indexOf(found), 1);
    }
  },
  handle(state, payload) {
    state.handled.push(payload);
  },
  unhandle(state, payload) {
    const index = state.handled.indexOf(payload);
    if (index >= 0) {
      state.handled.splice(index, 1);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
